/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "./type";
export var ControlDisplayDensity = /*@__PURE__*/ (function (ControlDisplayDensity) {
    ControlDisplayDensity[ControlDisplayDensity["Auto"] = 0] = "Auto";
    ControlDisplayDensity[ControlDisplayDensity["Comfortable"] = 1] = "Comfortable";
    ControlDisplayDensity[ControlDisplayDensity["Cosy"] = 2] = "Cosy";
    ControlDisplayDensity[ControlDisplayDensity["Compact"] = 3] = "Compact";
    return ControlDisplayDensity;
})({});
/**
 * @hidden
 */
export var ControlDisplayDensity_$type = /*@__PURE__*/ markEnum('ControlDisplayDensity', 'Auto,0|Comfortable,1|Cosy,2|Compact,3');
//# sourceMappingURL=ControlDisplayDensity.js.map
